import { render, staticRenderFns } from "./CreateProfile.vue?vue&type=template&id=3045267c&scoped=true"
import script from "./CreateProfile.vue?vue&type=script&lang=js"
export * from "./CreateProfile.vue?vue&type=script&lang=js"
import style0 from "./CreateProfile.vue?vue&type=style&index=0&id=3045267c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3045267c",
  null
  
)

export default component.exports